<script lang="ts">
    import { LL } from "../../../../i18n/i18n-svelte";
    import { mapEditorShowGridStore, mapEditorTilePreviewStore } from "../../../Stores/MapEditorStore";
    import BrushToolbar from "./BrushToolbar.svelte";
    import LayersPanel from "./LayersPanel.svelte";
    import ResizeMapDialog from "./ResizeMapDialog.svelte";
    import TilePalette from "./TilePalette.svelte";
</script>

<div class="flex flex-col gap-4">
    <div class="flex items-center gap-3 text-xs">
        <label class="flex items-center gap-1 cursor-pointer">
            <input type="checkbox" bind:checked={$mapEditorShowGridStore} />
            {$LL.mapEditor.tilemapEditor.showGrid()}
        </label>
        <label class="flex items-center gap-1 cursor-pointer">
            <input type="checkbox" bind:checked={$mapEditorTilePreviewStore} />
            {$LL.mapEditor.tilemapEditor.tilePreview()}
        </label>
    </div>
    <BrushToolbar />
    <LayersPanel />
    <TilePalette />
    <ResizeMapDialog />
</div>
